
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"12","cy":"12","r":"12","fill":"#43B4EB"}}),_c('path',{attrs:{"d":"M16.5 12.748h-3.75v3.75a.75.75 0 11-1.5 0v-3.75H7.5a.75.75 0 110-1.5h3.75v-3.75a.75.75 0 111.5 0v3.75h3.75a.75.75 0 010 1.5z","fill":"#fff"}})])
          )
        }
      }
    